<template>
  <div>
    <div class="club-info-modal-description px-2">
      <div class="text-h6 text--text mb-2">
        {{ $t('Что даёт клуб', options) }}
      </div>
      <div class="text-body-1 text--text">
        {{ $t('Возможность получить скидку 30% на консультацию у врача.', options) }}
      </div>
      <div class="text-h6 text--text mt-8 mb-2">
        {{ $t('Как получить купон и скидку', options) }}
      </div>
      <div class="b-club-list text-body-1 text--text">
        <div class="b-club-list__item">
          {{ $t('Оплатите на сайте ПроДокторов 50% стоимости консультации по клубной цене', options) }}
        </div>
        <div class="b-club-list__item">
          {{ $t('Получите клубный купон на скидку', options) }}
        </div>
        <div class="b-club-list__item">
          {{ $t('В день визита оплачиваете в клинике оставшиеся 50%', options) }}
        </div>
      </div>
      <div class="text-h6 text--text mt-8 mb-2">
        {{ $t('Как вступить в клуб', options) }}
      </div>
      <div class="text-body-1 text--text mb-4">
        {{ $t(CLUB_MODAL_TEXT.useClubPrice, options) }}
      </div>
    </div>
    <div class="text-h6 text--text mt-10 mb-4 px-2 mt-8">
      {{ $t('Вопросы и ответы', options) }}
    </div>
    <v-expansion-panels
      class="px-2"
      multiple
    >
      <v-expansion-panel
        v-for="(item, index) in expansionPanel"
        :key="`${componentName}ExpansionItem${index}`"
      >
        <v-expansion-panel-header
          :expand-icon="vuetifyIcons.arrowDown"
        >
          <span class="text-body-1">{{ $t(item.title, options) }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="text-body-1">
          {{ $t(item.description, options) }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="mt-10 px-2">
      <div class="text-body-2 text-secondary--text text-center">
        © 2011 — {{ nowYear }}, ООО «МЕДРОКЕТ»‎
      </div>
      <div class="d-block text-body-2 text-secondary--text mt-2 text-center">
        {{ $t('Оплачивая, вы соглашаетесь', options) }}
        {{ $t('с', options) }}<a
          :href="pdfData.coupon"
          rel="noopener noreferrer"
          target="_blank"
          class="text-secondary--text"
        >{{ $t('офертой', options) }}</a>
        {{ $t('и', options) }}<a
          :href="pdfData.participation"
          rel="noopener noreferrer"
          target="_blank"
          class="text-secondary--text"
        >{{ $t('правилами клуба', options) }}</a>
        <!-- eslint-enable vue/no-template-target-blank -->
      </div>
    </div>
  </div>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import ClubInfoModalLogic from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalLogic'
import ClubInfoModalExpansionPanel from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalExpansionPanel'

export default {
  name: 'ClubInfoModalContent',
  vuetify,
  mixins: [
    ClubInfoModalLogic,
    ClubInfoModalExpansionPanel,
  ],
  data() {
    return {
      CLUB_MODAL_TEXT: { useClubPrice: 'Просто воспользуйтесь клубной ценой и вы станете участником клуба на 6 месяцев. После доступ к клубным ценам на 6 месяцев будет стоить 99 ₽.' },
      options: { ns: this.$i18next.language },
    }
  },
}
</script>
